import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';
import SearchIcon from '@mui/icons-material/Search';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const FiltroListIpb = ({ handleSubmit, onSubmit, register, errors }) => {
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={1} alignItems='center'>
        <Grid item size={{ xs: 12, xl: 1.2 }}>
          <TextField
            fullWidth
            label='Desde'
            type='date'
            {...register('from_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.from_date)}
            helperText={errors.from_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, xl: 1.2 }}>
          <TextField
            fullWidth
            label='Hasta'
            type='date'
            {...register('to_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.to_date)}
            helperText={errors.to_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>

        <Grid item size={{ xs: 12, xl: 2 }}>
          <TextField
            fullWidth
            label='ICCID'
            {...register('icc_number', {
              pattern: {
                value: /^[0-9]+$/,
                message: 'ICCID',
              },
            })}
            error={Boolean(errors.icc_number)}
            helperText={errors.icc_number?.message}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }}
          />
        </Grid>

        <Grid item size={{ xs: 12, xl: 1 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default FiltroListIpb;
